<template>
  <div class="basis-2/5 text-nowrap bg-white py-3xs">
    <ArrowButton
      @click="navigation.closeArendeView"
      text="Alla ärenden"
      variant="left"
    />
  </div>
  <div class="flex flex-col items-center gap-xs py-sm" v-if="arende.isLoading">
    <SmallSpinner />
    <span>Laddar ärendet...</span>
  </div>
  <template v-else>
    <h2 class="type-heading-md my-sm">{{ arende.data?.rubrik }}</h2>
    <ArendeIdDate
      class="mb-sm"
      :id="arende.data?.id"
      :date="formatDateToYYYYMMDD(arende.data?.createdAt)"
    />
    <ArendeForm :arende="arende.data!" />
  </template>
</template>
<script setup lang="ts">
import { computed } from "vue";

import ArendeIdDate from "@/components/arende-components/ArendeIdDate.vue";
import ArrowButton from "@/components/ui/ArrowButton.vue";
import SmallSpinner from "@/components/ui/SmallSpinner.vue";
import { useNavigation } from "@/composables/useNavigation";
import { formatDateToYYYYMMDD } from "@/common/formatters";

import { useArbetsgivarearendenStore } from "../../store";
import ArendeForm from "../ArendeForm.vue";

const navigation = useNavigation();
const arendeStore = useArbetsgivarearendenStore();
const arende = computed(() => arendeStore.arende);
</script>
